import _toConsumableArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { Path } from '@antv/g';
import { path as d3Path } from 'd3-path';
import { sort } from 'd3-array';
import { select } from '../utils/selection';
import { mapObject } from '../utils/array';
import { ELEMENT_CLASS_NAME, PLOT_CLASS_NAME } from '../runtime';
import { isOrdinalScale } from '../utils/scale';
import { rect } from '../shape/interval/color';
import { isPolar, isTranspose } from '../utils/coordinate';
import { getStyle } from '../utils/style';
import { reorder } from '../shape/utils';
import { angle, angleBetween, sub } from '../utils/vector';
/**
 * Given root of chart returns elements to be manipulated
 */
export function selectG2Elements(root) {
  return select(root).selectAll(".".concat(ELEMENT_CLASS_NAME)).nodes().filter(function (d) {
    return !d.__removed__;
  });
}
export function selectFacetG2Elements(target, viewInstances) {
  return selectFacetViews(target, viewInstances).flatMap(function (_ref) {
    var container = _ref.container;
    return selectG2Elements(container);
  });
}
export function selectFacetViews(target, viewInstances) {
  return viewInstances.filter(function (d) {
    return d !== target && d.options.parentKey === target.options.key;
  });
}
export function selectPlotArea(root) {
  return select(root).select(".".concat(PLOT_CLASS_NAME)).node();
}
export function mousePosition(target, event) {
  var offsetX = event.offsetX,
    offsetY = event.offsetY;
  var bbox = target.getRenderBounds();
  var _bbox$min = _slicedToArray(bbox.min, 2),
    x = _bbox$min[0],
    y = _bbox$min[1],
    _bbox$max = _slicedToArray(bbox.max, 2),
    x1 = _bbox$max[0],
    y1 = _bbox$max[1];
  var isOutX = offsetX < x || offsetX > x1;
  var isOutY = offsetY < y || offsetY > y1;
  if (isOutX || isOutY) return null;
  return [offsetX - x, offsetY - y];
}
/**
 * @todo Pass bbox rather than calc it here.
 */
export function brushMousePosition(target, event) {
  var offsetX = event.offsetX,
    offsetY = event.offsetY;
  var _boundsOfBrushArea = boundsOfBrushArea(target),
    _boundsOfBrushArea2 = _slicedToArray(_boundsOfBrushArea, 4),
    x = _boundsOfBrushArea2[0],
    y = _boundsOfBrushArea2[1],
    x1 = _boundsOfBrushArea2[2],
    y1 = _boundsOfBrushArea2[3];
  return [Math.min(x1, Math.max(x, offsetX)) - x, Math.min(y1, Math.max(y, offsetY)) - y];
}
export function boundsOfBrushArea(target) {
  // Calc bbox after clipping.
  var bbox = target.getRenderBounds();
  var _bbox$min2 = _slicedToArray(bbox.min, 2),
    x0 = _bbox$min2[0],
    y0 = _bbox$min2[1],
    _bbox$max2 = _slicedToArray(bbox.max, 2),
    x1 = _bbox$max2[0],
    y1 = _bbox$max2[1];
  return [x0, y0, x1, y1];
}
export function createColorKey(view) {
  return function (element) {
    return element.__data__.color;
  };
}
export function createXKey(view) {
  var scaleX = view.scale.x;
  return function (element) {
    var x = element.__data__.x;
    return scaleX.invert(x);
  };
}
export function createDatumof(view) {
  var views = Array.isArray(view) ? view : [view];
  var keyData = new Map(views.flatMap(function (view) {
    var marks = Array.from(view.markState.keys());
    return marks.map(function (mark) {
      return [keyed(view.key, mark.key), mark.data];
    });
  }));
  return function (element) {
    var _element$__data__ = element.__data__,
      index = _element$__data__.index,
      markKey = _element$__data__.markKey,
      viewKey = _element$__data__.viewKey;
    var data = keyData.get(keyed(viewKey, markKey));
    return data[index];
  };
}
/**
 * A state manager for G2Element.
 * The keys for each state's style start with the state name.
 * { selectedFill, selectedStroke } is for selected state.
 * { unselectedFill, unselectedStroke } is for unselected state.
 */
export function useState(style) {
  var valueof = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (d, element) {
    return d;
  };
  var setAttribute = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (element, key, v) {
    return element.setAttribute(key, v);
  };
  var STATES = '__states__';
  var ORIGINAL = '__ordinal__';
  // Mix style for each state and apply it to element.
  var updateState = function updateState(element) {
    var _element$STATES = element[STATES],
      states = _element$STATES === void 0 ? [] : _element$STATES,
      _element$ORIGINAL = element[ORIGINAL],
      original = _element$ORIGINAL === void 0 ? {} : _element$ORIGINAL;
    var stateStyle = states.reduce(function (mixedStyle, state) {
      return Object.assign(Object.assign({}, mixedStyle), style[state]);
    }, original);
    if (Object.keys(stateStyle).length === 0) return;
    for (var _i = 0, _Object$entries = Object.entries(stateStyle); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];
      var currentValue = getStyle(element, key);
      var v = valueof(value, element);
      setAttribute(element, key, v);
      // Store the attribute if it does not exist in original.
      if (!(key in original)) original[key] = currentValue;
    }
    element[ORIGINAL] = original;
  };
  var initState = function initState(element) {
    if (element[STATES]) return;
    element[STATES] = [];
    return;
  };
  /**
   * Set the states and update element.
   */
  var setState = function setState(element) {
    initState(element);
    for (var _len = arguments.length, states = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      states[_key - 1] = arguments[_key];
    }
    element[STATES] = [].concat(states);
    updateState(element);
  };
  /**
   * Remove the states and update element.
   */
  var removeState = function removeState(element) {
    initState(element);
    for (var _len2 = arguments.length, states = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      states[_key2 - 1] = arguments[_key2];
    }
    for (var _i2 = 0, _states = states; _i2 < _states.length; _i2++) {
      var state = _states[_i2];
      var index = element[STATES].indexOf(state);
      if (index !== -1) {
        element[STATES].splice(index, 1);
      }
    }
    updateState(element);
  };
  var hasState = function hasState(element, state) {
    initState(element);
    return element[STATES].indexOf(state) !== -1;
  };
  return {
    setState: setState,
    removeState: removeState,
    hasState: hasState
  };
}
function isEmptyObject(obj) {
  if (obj === undefined) return true;
  if (typeof obj !== 'object') return false;
  return Object.keys(obj).length === 0;
}
// A function to generate key for mark each view.
function keyed(viewKey, markKey) {
  return "".concat(viewKey, ",").concat(markKey);
}
export function mergeState(options, states) {
  // Index state by mark key and view key.
  var views = Array.isArray(options) ? options : [options];
  var markState = views.flatMap(function (view) {
    return view.marks.map(function (mark) {
      return [keyed(view.key, mark.key), mark.state];
    });
  });
  var state = {};
  // Update each specified state.
  var _iterator = _createForOfIteratorHelper(states),
    _step;
  try {
    var _loop = function _loop() {
      var descriptor = _step.value;
      var _ref2 = Array.isArray(descriptor) ? descriptor : [descriptor, {}],
        _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        defaults = _ref3[1]; // Update each specified mark state.
      state[key] = markState.reduce(function (merged, mark) {
        // Normalize state.
        var _mark = _slicedToArray(mark, 2),
          markKey = _mark[0],
          _mark$ = _mark[1],
          markState = _mark$ === void 0 ? {} : _mark$;
        var selectedState = isEmptyObject(markState[key]) ? defaults : markState[key];
        // Update each state attribute.
        var _loop2 = function _loop2() {
          var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i3], 2),
            attr = _Object$entries2$_i[0],
            value = _Object$entries2$_i[1];
          var oldValue = merged[attr];
          var newValue = function newValue(data, index, array, element) {
            var k = keyed(element.__data__.viewKey, element.__data__.markKey);
            if (markKey !== k) return oldValue === null || oldValue === void 0 ? void 0 : oldValue(data, index, array, element);
            if (typeof value !== 'function') return value;
            return value(data, index, array, element);
          };
          merged[attr] = newValue;
        };
        for (var _i3 = 0, _Object$entries2 = Object.entries(selectedState); _i3 < _Object$entries2.length; _i3++) {
          _loop2();
        }
        return merged;
      }, {});
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return state;
}
// @todo Support elements from different view.
export function createValueof(elements, datum) {
  var elementIndex = new Map(elements.map(function (d, i) {
    return [d, i];
  }));
  var fa = datum ? elements.map(datum) : elements;
  return function (d, e) {
    if (typeof d !== 'function') return d;
    var i = elementIndex.get(e);
    var fe = datum ? datum(e) : e;
    return d(fe, i, fa, e);
  };
}
export function renderLink(_a) {
  var _a$link = _a.link,
    link = _a$link === void 0 ? false : _a$link,
    _a$valueof = _a.valueof,
    valueof = _a$valueof === void 0 ? function (d, element) {
      return d;
    } : _a$valueof,
    coordinate = _a.coordinate,
    style = __rest(_a, ["link", "valueof", "coordinate"]);
  var LINK_CLASS_NAME = 'element-link';
  if (!link) return [function () {}, function () {}];
  var pointsOf = function pointsOf(element) {
    return element.__data__.points;
  };
  var pathPointsOf = function pathPointsOf(P0, P1) {
    var _P = _slicedToArray(P0, 3),
      p1 = _P[1],
      p2 = _P[2];
    var _P2 = _slicedToArray(P1, 4),
      p0 = _P2[0],
      p3 = _P2[3];
    var P = [p1, p0, p3, p2];
    return P;
  };
  var append = function append(elements) {
    var _a;
    if (elements.length <= 1) return;
    // Sort elements by normalized x to avoid cross.
    var sortedElements = sort(elements, function (e0, e1) {
      var x0 = e0.__data__.x;
      var x1 = e1.__data__.x;
      var dx = x0 - x1;
      return dx;
    });
    var _loop3 = function _loop3() {
      var p = d3Path();
      var e0 = sortedElements[i - 1];
      var e1 = sortedElements[i];
      var _pathPointsOf = pathPointsOf(pointsOf(e0), pointsOf(e1)),
        _pathPointsOf2 = _slicedToArray(_pathPointsOf, 4),
        p0 = _pathPointsOf2[0],
        p1 = _pathPointsOf2[1],
        p2 = _pathPointsOf2[2],
        p3 = _pathPointsOf2[3];
      p.moveTo.apply(p, _toConsumableArray(p0));
      p.lineTo.apply(p, _toConsumableArray(p1));
      p.lineTo.apply(p, _toConsumableArray(p2));
      p.lineTo.apply(p, _toConsumableArray(p3));
      p.closePath();
      var _b = mapObject(style, function (d) {
          return valueof(d, e0);
        }),
        _b$fill = _b.fill,
        fill = _b$fill === void 0 ? e0.getAttribute('fill') : _b$fill,
        rest = __rest(_b, ["fill"]);
      var link = new Path({
        className: LINK_CLASS_NAME,
        style: Object.assign({
          d: p.toString(),
          fill: fill,
          zIndex: -2
        }, rest)
      });
      // @ts-ignore
      (_a = e0.link) === null || _a === void 0 ? void 0 : _a.remove();
      e0.parentNode.appendChild(link);
      // @ts-ignore
      e0.link = link;
    };
    for (var i = 1; i < sortedElements.length; i++) {
      _loop3();
    }
  };
  var remove = function remove(element) {
    var _a;
    (_a = element.link) === null || _a === void 0 ? void 0 : _a.remove();
    element.link = null;
  };
  return [append, remove];
}
// Apply translate to mock slice out.
export function offsetTransform(element, offset, coordinate) {
  var append = function append(t) {
    var transform = element.style.transform;
    return transform ? "".concat(transform, " ").concat(t) : t;
  };
  if (isPolar(coordinate)) {
    var points = element.__data__.points;
    var _ref4 = isTranspose(coordinate) ? reorder(points) : points,
      _ref5 = _slicedToArray(_ref4, 2),
      p0 = _ref5[0],
      p1 = _ref5[1];
    var center = coordinate.getCenter();
    var v0 = sub(p0, center);
    var v1 = sub(p1, center);
    var a0 = angle(v0);
    var da = angleBetween(v0, v1);
    var amid = a0 + da / 2;
    var dx = offset * Math.cos(amid);
    var dy = offset * Math.sin(amid);
    return append("translate(".concat(dx, ", ").concat(dy, ")"));
  }
  if (isTranspose(coordinate)) return append("translate(".concat(offset, ", 0)"));
  return append("translate(0, ".concat(-offset, ")"));
}
export function renderBackground(_a) {
  var document = _a.document,
    background = _a.background,
    scale = _a.scale,
    coordinate = _a.coordinate,
    valueof = _a.valueof,
    rest = __rest(_a, ["document", "background", "scale", "coordinate", "valueof"]);
  var BACKGROUND_CLASS_NAME = 'element-background';
  // Don't have background.
  if (!background) return [function () {}, function () {}];
  var extentOf = function extentOf(scale, x, padding) {
    var ax = scale.invert(x);
    var mid = x + scale.getBandWidth(ax) / 2;
    var half = scale.getStep(ax) / 2;
    var offset = half * padding;
    return [mid - half + offset, mid + half - offset];
  };
  var sizeXOf = function sizeXOf(element, padding) {
    var scaleX = scale.x;
    if (!isOrdinalScale(scaleX)) return [0, 1];
    var data = element.__data__;
    var x = data.x;
    var _extentOf = extentOf(scaleX, x, padding),
      _extentOf2 = _slicedToArray(_extentOf, 2),
      e1 = _extentOf2[0],
      e2 = _extentOf2[1];
    return [e1, e2];
  };
  var sizeYOf = function sizeYOf(element, padding) {
    var scaleY = scale.y;
    if (!isOrdinalScale(scaleY)) return [0, 1];
    var data = element.__data__;
    var y = data.y;
    var _extentOf3 = extentOf(scaleY, y, padding),
      _extentOf4 = _slicedToArray(_extentOf3, 2),
      e1 = _extentOf4[0],
      e2 = _extentOf4[1];
    return [e1, e2];
  };
  var bandShapeOf = function bandShapeOf(element, style) {
    var padding = style.padding;
    var _sizeXOf = sizeXOf(element, padding),
      _sizeXOf2 = _slicedToArray(_sizeXOf, 2),
      x1 = _sizeXOf2[0],
      x2 = _sizeXOf2[1];
    var _sizeYOf = sizeYOf(element, padding),
      _sizeYOf2 = _slicedToArray(_sizeYOf, 2),
      y1 = _sizeYOf2[0],
      y2 = _sizeYOf2[1];
    var points = [[x1, y1], [x2, y1], [x2, y2], [x1, y2]].map(function (d) {
      return coordinate.map(d);
    });
    var data = element.__data__;
    var dy = data.y,
      dy1 = data.y1;
    return rect(document, points, {
      y: dy,
      y1: dy1
    }, coordinate, style);
  };
  // Shape without ordinal style.
  // Clone and scale it.
  var cloneShapeOf = function cloneShapeOf(element, style) {
    var _style$transform = style.transform,
      transform = _style$transform === void 0 ? 'scale(1.2, 1.2)' : _style$transform,
      _style$transformOrigi = style.transformOrigin,
      transformOrigin = _style$transformOrigi === void 0 ? 'center center' : _style$transformOrigi,
      _style$stroke = style.stroke,
      stroke = _style$stroke === void 0 ? '' : _style$stroke,
      rest = __rest(style, ["transform", "transformOrigin", "stroke"]);
    var finalStyle = Object.assign({
      transform: transform,
      transformOrigin: transformOrigin,
      stroke: stroke
    }, rest);
    var shape = element.cloneNode(true);
    for (var _i4 = 0, _Object$entries3 = Object.entries(finalStyle); _i4 < _Object$entries3.length; _i4++) {
      var _Object$entries3$_i = _slicedToArray(_Object$entries3[_i4], 2),
        key = _Object$entries3$_i[0],
        value = _Object$entries3$_i[1];
      shape.style[key] = value;
    }
    return shape;
  };
  var isOrdinalShape = function isOrdinalShape() {
    var x = scale.x,
      y = scale.y;
    return [x, y].some(isOrdinalScale);
  };
  var append = function append(element) {
    if (element.background) element.background.remove();
    var _a = mapObject(rest, function (d) {
        return valueof(d, element);
      }),
      _a$fill = _a.fill,
      fill = _a$fill === void 0 ? '#CCD6EC' : _a$fill,
      _a$fillOpacity = _a.fillOpacity,
      fillOpacity = _a$fillOpacity === void 0 ? 0.3 : _a$fillOpacity,
      _a$zIndex = _a.zIndex,
      zIndex = _a$zIndex === void 0 ? -2 : _a$zIndex,
      _a$padding = _a.padding,
      padding = _a$padding === void 0 ? 0.001 : _a$padding,
      _a$strokeWidth = _a.strokeWidth,
      strokeWidth = _a$strokeWidth === void 0 ? 0 : _a$strokeWidth,
      style = __rest(_a, ["fill", "fillOpacity", "zIndex", "padding", "strokeWidth"]);
    var finalStyle = Object.assign(Object.assign({}, style), {
      fill: fill,
      fillOpacity: fillOpacity,
      zIndex: zIndex,
      padding: padding,
      strokeWidth: strokeWidth
    });
    var shapeOf = isOrdinalShape() ? bandShapeOf : cloneShapeOf;
    var shape = shapeOf(element, finalStyle);
    shape.className = BACKGROUND_CLASS_NAME;
    element.parentNode.appendChild(shape);
    element.background = shape;
  };
  var remove = function remove(element) {
    var _a;
    (_a = element.background) === null || _a === void 0 ? void 0 : _a.remove();
    element.background = null;
  };
  var is = function is(element) {
    return element.className === BACKGROUND_CLASS_NAME;
  };
  return [append, remove, is];
}
export function setCursor(root, cursor) {
  // @ts-ignore
  var canvas = root.getRootNode().defaultView;
  var dom = canvas.getContextService().getDomElement();
  if (dom === null || dom === void 0 ? void 0 : dom.style) dom.style.cursor = cursor;
}
export function restoreCursor(root) {
  setCursor(root, 'default');
}
export function selectElementByData(elements, data, datum) {
  return elements.find(function (d) {
    return Object.entries(data).every(function (_ref6) {
      var _ref7 = _slicedToArray(_ref6, 2),
        key = _ref7[0],
        value = _ref7[1];
      return datum(d)[key] === value;
    });
  });
}